/**
 * Lazy-loads iframes when they enter the viewport.
 * Prevents render-blocking from heavy third-party widgets (reviews, calendars).
 */
export const initLazyIframes = (): void => {
  const lazyIframes = document.querySelectorAll<HTMLIFrameElement>('.lazy-load-iframe');
  
  if (!lazyIframes.length) return;

  // Check for IntersectionObserver support
  if ('IntersectionObserver' in window) {
    const iframeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const iframe = entry.target as HTMLIFrameElement;
          const src = iframe.getAttribute('data-src');
          if (src) {
            iframe.src = src; // Trigger load
            iframe.removeAttribute('data-src'); // Clean up
            iframeObserver.unobserve(iframe); // Stop observing
          }
        }
      });
    }, {
      // Start loading when within 100px of viewport
      rootMargin: '100px',
      threshold: 0,
    });

    lazyIframes.forEach(iframe => iframeObserver.observe(iframe));
  } else {
    // Fallback: load all after 3 seconds idle
    setTimeout(() => {
      lazyIframes.forEach(iframe => {
        const src = iframe.getAttribute('data-src');
        if (src) {
          iframe.src = src;
          iframe.removeAttribute('data-src');
        }
      });
    }, 3000);
  }
};
